import { render } from "./NoticeBox.vue?vue&type=template&id=3c005198&scoped=true&lang=pug"
import script from "./NoticeBox.vue?vue&type=script&lang=js"
export * from "./NoticeBox.vue?vue&type=script&lang=js"

import "./NoticeBox.vue?vue&type=style&index=0&id=3c005198&lang=scss&scoped=true"

import exportComponent from "/Users/aladdin/Documents/Petar/fairwey-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c005198"]])

export default __exports__